// API Base URL
export const BASE_URL = 'https://testidentity.digitalsignature.com.bd:7000/identityverify';

// API Endpoints
export const API_ENDPOINTS = {
  NID_AUTH: `${BASE_URL}/auth/token`,
  NID_FACE_VERIFICATION: `${BASE_URL}/api/nid-face-verification`
};

// NID Auth Credentials
export const NID_AUTH_CREDENTIALS = {
  clientId: '276893700486-actcrpoiu5vsjq792ond2f7dqg8fe5kg.apps.ecipher.co',
  clientSecret: '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'
};

// Error Codes
export const ERROR_CODES = {
  E100: 'E100',
  E101: 'E101',
  E102: 'E102',
  E103: 'E103',
  E500: 'E500'
};

// Error Messages
export const ERROR_MESSAGES = {
  E100: 'OCR Failed',
  E101: 'NID / DOB Mismatch',
  E102: 'EC API Timeout',
  E103: 'Liveliness Failed',
  E500: 'Unexpected SDK Error'
};
